module.exports = __webpack_public_path__ + "images/ea579b8c671b045ffbfb750ed67b7c64-brkfst.png";